import { render, staticRenderFns } from "./TheMyOrdersWrapper.vue?vue&type=template&id=1e3ebfc2&scoped=true"
import script from "./TheMyOrdersWrapper.vue?vue&type=script&lang=js"
export * from "./TheMyOrdersWrapper.vue?vue&type=script&lang=js"
import style0 from "./TheMyOrdersWrapper.vue?vue&type=style&index=0&id=1e3ebfc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3ebfc2",
  null
  
)

export default component.exports